import { ROUTE } from "../../../../routes";
import SharedPropsService from "../../../../SharedPropsService";
import { nextStepId } from "../../../../configs/utils";
export const confirmPan = async (action, _datastore, { instrumentTrack, asyncStorage, goBack, setDatastore, navigate, navigateWithClear, ...props }) => {
    instrumentTrack("CONFIRM_PAN_BUTTON_CLICKED");
    console.log("A$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    const user = await SharedPropsService.getUser();
    user.linkedBorrowerAccounts[0].accountHolderPAN = action.payload.panNumber;
    await SharedPropsService.setUser(user);
    await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, action.payload.widgetId, {
        subTitle: user.linkedBorrowerAccounts[0].accountHolderPAN,
    });
    const routeObj = await nextStepId(action.payload.currentStepId);
    console.log("route obj", action.payload.currentStepId);
    //await goBack();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const changePanNo = async (action, _datastore, { goBack, instrumentTrack }) => {
    instrumentTrack("EDIT_PAN_BUTTON_CLICKED");
    goBack();
};
